<template>
  <v-list>
    <v-list-group no-action prepend-icon="fas fa-tools">
      <template v-slot:activator>
        <v-list-item-title>{{
          $t("global.menu.configurations")
        }}</v-list-item-title>
      </template>
      <v-list-item link :to="{ name: 'organizationParameters' }">
        <v-list-item-icon>
          <v-icon>fas fa-boxes</v-icon>
        </v-list-item-icon>
        <v-list-item-content>
          <v-list-item-title>{{
            $t("global.menu.organizationParameters")
          }}</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
      <v-list-item link :to="{ name: 'clients' }">
        <v-list-item-icon>
          <v-icon>fas fa-user</v-icon>
        </v-list-item-icon>
        <v-list-item-content>
          <v-list-item-title>
            {{ $t("global.menu.clients") }}
          </v-list-item-title>
        </v-list-item-content>
      </v-list-item>
      <v-list-item link :to="{ name: 'productsTypes' }">
        <v-list-item-icon>
          <v-icon>fas fa-boxes</v-icon>
        </v-list-item-icon>
        <v-list-item-content>
          <v-list-item-title>{{
            $t("global.menu.productsTypes")
          }}</v-list-item-title>
        </v-list-item-content>
      </v-list-item>
    </v-list-group>
    <v-list-item link :to="{ name: 'purchaseData' }">
      <v-list-item-icon>
        <v-icon>fas fa-money-check-alt</v-icon>
      </v-list-item-icon>
      <v-list-item-content>
        <v-list-item-title>{{
          $t("global.menu.purchaseData")
        }}</v-list-item-title>
      </v-list-item-content>
    </v-list-item>
    <v-list-item link :to="{ name: 'statistics' }">
      <v-list-item-icon>
        <v-icon>fas fa-chart-area</v-icon>
      </v-list-item-icon>
      <v-list-item-content>
        <v-list-item-title>{{
          $t("global.menu.statistics")
        }}</v-list-item-title>
      </v-list-item-content>
    </v-list-item>
  </v-list>
</template>

<script>
export default {
  name: "Menu"
};
</script>
